<template>
  <div class="about">
    <h1>A site for event around the world</h1>
  </div>
</template>
